import { Platform } from 'react-native';

import { useFeatureFlag } from '@order/LaunchDarkly';

export const useLocationPermissionPrimerEnabled = () => {
  const locationPrimerVariant = useFeatureFlag('CELS-5256-geofencing-primer-variant');

  const supportedVariants: (typeof locationPrimerVariant)[] = ['A', 'B', 'C'];
  const isSupportedVariant = supportedVariants.includes(locationPrimerVariant);

  return {
    canEnableLocationPrimer: Platform.OS !== 'web' && isSupportedVariant,
    locationPrimerVariant,
  };
};
